require('../../modules/es7.object.get-own-property-descriptors');
module.exports = require('../../modules/_core').Object.getOwnPropertyDescriptors;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/get-own-property-descriptors.js
// module id = 2085
// module chunks = 67